import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.service-analysis')
  .factory('$serviceAnalysis', serviceAnalysisObjectFactory);

/* @ngInject */
function serviceAnalysisObjectFactory($bringozFactory: $bringozFactory,
                                      ServiceAnalysisApi: BringozApi,
                                      ServiceAnalysis_DS: DataStoreConfig,
                                      ServiceAnalysis_PN: PushNotificationsConfig) {

  function $serviceAnalysis(id: string) {
    return $bringozFactory(id, ServiceAnalysisApi, ServiceAnalysis_DS, ServiceAnalysis_PN);
  }

  return $serviceAnalysis;
}
